class ControllerType {
	static Default = 1;
	static Rodecaster = 2;
}

export default ControllerType;